const colors = {
  TRU_BLUE_PRIMARY: "#4C638C",
  TRU_BLUE_SECONDARY: "#65A2CB",
  TRU_GREEN_PRIMARY: "#3EB6AE",
  TRU_GREEN_SECONDARY: "#8ACFC2",
  TRU_BROWN_PRIMARY: "#AD5D4E",
  TRU_YELLOW_PRIMARY: "#E0CA3C",
}

export default colors